import { useContext } from "react";
import { useQuery } from "react-query";

import { UserContext } from "@/components/User";
import { fetchJobApplication } from "@/data/job-applications";
import { buildJobApplicationQueryKey } from "@/data/job-applications/queries/buildJobApplicationQueryKey";

export const useJobApplicationQuery = (id: number) => {
  const { contextCompany, contextConsultantProfileId } = useContext(UserContext);

  const queryKey = buildJobApplicationQueryKey(contextConsultantProfileId, id);

  const query = useQuery(queryKey, () => fetchJobApplication({ companyId: contextCompany?.id, jobApplicationId: id }));

  return {
    data: query.data!,
    refetch: query.refetch,
  };
};
